import type { ReactNode } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { Label } from '@/components/ui/label';

/** A labelled form field with an inline, animated error message. */
export function Field({ id, label, error, hint, children }: { id?: string; label: ReactNode; error?: string | null; hint?: ReactNode; children: ReactNode }) {
  return (
    <div className="grid gap-2">
      <Label htmlFor={id} className="text-sm font-semibold">
        {label}
      </Label>
      {children}
      <AnimatePresence initial={false}>
        {error ? (
          <motion.p
            key="error"
            id={id ? `${id}-error` : undefined}
            role="alert"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="text-destructive text-sm"
          >
            {error}
          </motion.p>
        ) : hint ? (
          <p className="text-muted-foreground text-sm">{hint}</p>
        ) : null}
      </AnimatePresence>
    </div>
  );
}
